'use client'

import { ShopProduct } from '@repo/shop/types'
import { Button, ButtonVariant } from '@repo/ui/components/button'
import { FunctionComponent, ReactNode } from 'react'
import { SHEET, useSheet } from '../../../providers/SheetProvider'
import { useWishlist } from '../../../providers/WishlistProvider'
import { PageDto } from '../../../types/page.types'

interface Props {
  pageDto: PageDto
  products: ShopProduct[]
  variant?: ButtonVariant
  label?: ReactNode
  className?: string
}

const AddAllToWishlistButton: FunctionComponent<Props> = ({ pageDto, products, variant, label, className }) => {
  const { openSheet } = useSheet()
  const { addToWishlist, isPending } = useWishlist()

  const addAllToWishlist = () => {
    for (const product of products) {
      addToWishlist(product.shopifyProduct.handle)
    }

    openSheet(SHEET.WISHLIST)
  }

  if (products.length === 0) {
    return null
  }

  return (
    <Button onClick={addAllToWishlist} disabled={isPending} variant={variant} className={className}>
      {label || pageDto.dictionary?.wishlist?.addalltowishlist || 'Add all to wishlist'}
    </Button>
  )
}

export default AddAllToWishlistButton
